import { Actions, ActionTypes } from './actions';
import { serviceTypeAdapter, initialState, ServiceTypeState } from './state';

export function serviceTypeReducer(state = initialState, action: Actions): ServiceTypeState {
  switch (action.type) {
    case ActionTypes.FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }
    case ActionTypes.LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_SUCCESS: {
      return serviceTypeAdapter.setAll(action.items, {
        ...state,
        isLoading: false,
        error: null,
      });
    }

    default: {
      return state;
    }
  }
}
